import React, { ReactElement, useEffect } from 'react'
import { Accordion } from 'ui'
import AdvancedSettingsIcon from 'images/dashboard/devices/advanced-settings.svg'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setShouldOpenAdvancedSettings } from 'store/multiprofile/devices'

export default function AdvancedSettings({ children }: { children?: ReactElement }): ReactElement {
  const dispatch = useAppDispatch()
  const shouldOpenAdvancedSettings = useAppSelector(s => s.devices.shouldOpenAdvancedSettings)

  useEffect(() => {
    return () => {
      dispatch(setShouldOpenAdvancedSettings(false))
    }
  }, [dispatch])

  return (
    <Accordion
      id="advanced-settings"
      title="Advanced Settings"
      ariaLabelButtonName="advanced settings"
      buttonVariant="simple"
      titleIcon={AdvancedSettingsIcon}
      sxTitleContainer={{
        pr: '2.4rem',
        gap: '1.2rem',
      }}
      titleStyle={{
        color: 'aliceBlue60',
        fontSize: '1.2rem',
        textTransform: 'uppercase',
        textAlign: 'left',
      }}
      openTitleStyle={{
        color: 'aliceBlue',
        fontSize: '1.2rem',
        textTransform: 'uppercase',
        textAlign: 'left',
      }}
      containerStyle={{
        width: '100%',
        '& > div:first-of-type': {
          width: '100%',
          px: '1.6rem',
          backgroundColor: shouldOpenAdvancedSettings ? 'blue' : 'transparent',
          borderTop: '1px solid',
          borderColor: 'blueYonder15',
        },
        alignItems: 'center',
      }}
      buttonStyle={{
        width: '100%',
        justifyContent: 'space-between',
        px: 0,
        py: '0.8rem',
        fontSize: '1.8rem',
        fontWeight: 'bold',
      }}
      svgStyle={{
        backgroundColor: 'transparent',
        flexShrink: 0,
        '& svg': {
          flexShrink: 0,
        },
      }}
      isOpenControlled={shouldOpenAdvancedSettings}
      setIsOpenControlled={isOpen => {
        dispatch(setShouldOpenAdvancedSettings(isOpen))
      }}
    >
      {children}
    </Accordion>
  )
}
